

export const defaultFilters = () => ({
  pagination: {
    limit: 20,
    page: 1,
  },
  filter: {
    dateFrom: '',
    dateTo: '',
    createdBy: [],
    spendDateFrom: '',
    spendDateTo: '',
    partners: [],
    countries: [],
    partnerGroups: [],
    streams: [],
    advertisers: [],
  },

})
